app.directive('doneToggleButton', function ($http, $q, loginService, $log) {
    return {
        restrict: 'A',
        scope: {
            config: '<doneToggleButton'
        },
        transclude: true,
        link: function ($scope, $element, $attrs, $ctrls, $transclude) {

            var currentRequest = null;
            var config = $scope.config;
            delete $scope.config;

            if (config.type === 'all') {

                // Complete All button

                const dayNr = config.dayNr;
                const weekNr = config.weekNr;
                const programId = config.programId;
                const specificDate = config.specificDate;
                const dayExercises = $scope.$parent.programDetail.getDayExerciseItems(weekNr, dayNr);

                $element.html('<span class="fa fa-check"></span><span class="sg-exercise-check-all-text">'+config.btnText+'</span>');

                $element.on('click', function () {
                    modal = angular.element("#sgCompleteSessionExercise");
                    modal.find('.sg-session-exercise-modal-section-conditional').hide();
                    modal.find('#msg-bulk-save').show();
                    modal.find('#se-complete-form')
                        .unbind('submit')
                        .one('submit', function (evt) {
                            evt.preventDefault();
                            sendRequestMarkAllDone(programId, specificDate, weekNr, dayNr, dayExercises)
                                .then(function() {
                                    modal.modal('hide');
                                });
                        });

                    modal.modal();
                });

            } else {

                // Complete a single exercise button

                if (!config || !config.exerciseItemId || !config.serviceUrl) {
                    console.warn("Invalid config passed to doneToggleButton");
                    return;
                }

                $scope.state = !!config.state;

                var showCompleteModal = function (isDone) {
                    modal = angular.element("#sgCompleteSessionExercise");
                    var seCompleteForm = modal.find('#se-complete-form');
                    var exerciseItem = $scope.$parent.programDetail.getExerciseItem(config.exerciseItemId);

                    modal.find('#msg-need-weight').toggle(config.needWeights);
                    modal.find('#msg-not-need-weight').toggle(!config.needWeights);
                    modal.find('#msg-bulk-save').hide();

                    modal.find('#se-weight').removeAttr('required');
                    if (config.needWeights) {
                        modal.find('#se-weight').attr('required', "true");
                    }

                    seCompleteForm
                        .unbind('submit')
                        .one('submit', function (evt) {
                            evt.preventDefault();
                            sendToggleRequest(
                                exerciseItem,
                                isDone,
                                config.specificDate,
                                config.needWeights ? modal.find('#se-weight').val() : null,
                                config.weightUnit
                            ).then(function() {
                                modal.find('#se-weight').val('0');
                                modal.modal('hide');
                            });
                        });

                    modal.modal();
                };

                $element.on('click', function ($event) {
                    $event.preventDefault();

                    if (config.readOnly) {
                        return;
                    }

                    if ($scope.$parent.programDetail.isDone(config.exerciseItemId)) {
                        const exerciseItem = $scope.$parent.programDetail.getExerciseItem(config.exerciseItemId);
                        // Uncheck
                        sendToggleRequest(exerciseItem, false, config.specificDate);
                    } else {
                        // Check
                        $scope.$apply(function () {
                            showCompleteModal(true);
                        });
                    }
                });

                $transclude(function (clone, childScope) {
                    childScope.doneToggleButton = {
                        state: $scope.state
                    };

                    $scope.$watch('state', function (newValue) {
                        childScope.doneToggleButton.state = newValue;
                    });

                    $element.append(clone);
                });

            }

            function sendRequestMarkAllDone (programId, specificDate, weekNr, dayNr, exerciseItems) {
                return sendAjaxRequest({
                    programId: programId,
                    exerciseItemIds: exerciseItems,
                    done: true,
                    dayNr: dayNr,
                    weekNr: weekNr,
                    specificDate: specificDate
                }).then(function (sessions) {
                    // Mark all the respective exercises with green
                    for (var i = 0; i < sessions.length; i++) {
                        $scope.$parent.programDetail.sessionExercises.unshift(sessions[i]);
                    }
                });
            }

            function sendToggleRequest(exerciseItem, isDone, specificDate, weight, weightUnit) {
                // Tentatively switch the state so that the application feels more responsive
                $scope.state = isDone;

                return sendAjaxRequest({
                    programId: config.programId,
                    exerciseItemIds: [exerciseItem],
                    exerciseId: config.exerciseId,
                    done: isDone,
                    weight: weight,
                    weightUnit: weightUnit,
                    sets: exerciseItem.sets,
                    repetitions: exerciseItem.repetitions,
                    specificDate: specificDate
                }).then(function (sessions) {
                    if (isDone) {
                        $scope.$parent.programDetail.sessionExercises.unshift(sessions[0]);
                    } else {
                        $scope.$parent.programDetail.sessionExercises = $scope.$parent.programDetail.sessionExercises
                            .filter(function(record) {
                                return record.id !== sessions[0].id;
                            });
                    }
                });
            }

            function sendAjaxRequest(data) {
                if (currentRequest !== null) {
                    return;
                }

                currentRequest = $q.defer();

                return $http({
                    method: 'POST',
                    url: config.serviceUrl,
                    data: data,
                    responseType: 'json',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    timeout: currentRequest.promise
                }).then(function (httpResponse) {
                    currentRequest = null;

                    if (!httpResponse.data || !httpResponse.data[0]) {
                        throw new Error('Unexpected response from server');
                    }

                    return httpResponse.data;
                }).catch(function(httpError) {
                    currentRequest = null;
                    if (httpError.xhrStatus !== "abort") {
                        $log.error(httpError);
                    }
                    if (httpError.status === 403) {
                        if (loginService.isLoggedIn === false) {
                            loginService.redirectToLoginScreen(true);
                        } else if (httpError.headers('x-profile-upgrade-url')) {
                            window.location.href = httpError.headers('x-profile-upgrade-url');
                        }
                    }

                    throw new Error('An error occurred! Please try again later.');
                });
            }
        }
    };
});
